module.exports = "<div> <icon value=edit></icon> <icon value=input size=tiny></icon> <icon value=input size=small></icon> <icon value=input size=medium></icon> <icon value=input size=large></icon> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/icons/icon.vue
 ** module id = 261
 ** module chunks = 0
 **/